import { SearchSettings } from '../../typings/search-settings';

export const FretSearchSettings: SearchSettings = {
     aggs: [
    {
        id: 'kategorie',
        title: 'Kategorie',
        facetKeys: [
            'facet_doctype',
        ]
    },
    {
        id: 'ort',
        title: 'Stadt',
        facetKeys: [
            'facet_stadt',
        ]
    },
    {
        id: 'wahl',
        title: 'Wahl',
        facetKeys: [
            'facet_wahl',
        ]
    },
    {
        id: 'partei',
        title: 'Partei',
        facetKeys: [
            'facet_partei'
        ]
    },
    {
        id: 'gender',
        title: 'Geschlecht',
        facetKeys: [
            'facet_gender'
        ]
    },
    {
        id: 'person',
        title: 'Person',
        facetKeys: [
            'facet_person'
        ]
    },


    ],
    validDocTypes: ['_doc']
};
